import { routesApi } from './api/routesApi';
import { Route, ApiResponse } from '../types/route.types';

/**
 * Service métier pour les routes
 */
class RouteService {
  private cache: Map<string, Route[]> = new Map();
  private readonly USE_STATIC_DATA = true;

  /**
   * Récupère les routes pour une activité donnée
   */
  async fetchRoutes(activity?: string): Promise<Route[]> {
    const cacheKey = activity || 'all';

    // Vérifier le cache
    if (this.cache.has(cacheKey)) {
      return this.cache.get(cacheKey)!;
    }

    try {
      let response: ApiResponse;

      if (this.USE_STATIC_DATA) {
        response = await routesApi.getRoutesFromStatic(activity);
      } else {
        response = await routesApi.getRoutes({
          activities: activity,
          limit: 100000,
        });
      }

      // Mettre en cache
      this.cache.set(cacheKey, response.data);

      return response.data;
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Unknown error';
      throw new Error(`Failed to fetch routes: ${errorMessage}`);
    }
  }

  /**
   * Vide le cache
   */
  clearCache(): void {
    this.cache.clear();
  }
}

export const routeService = new RouteService();
